<h1 class="page-title">Settings</h1>

<div class="grid-container">
  <!-- Profile Information Form -->
  <app-card title="Profile Information">
    @if (isOidcUser === true) {
      <p>
        You are logged in with your SWITCH Account. You cannot change your profile
        information here. If you want to change your profile information, please
        do so in your SWITCH Profile settings.
      </p>
    }

    <form [formGroup]="profileForm">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            id="email"
            type="email"
            formControlName="email"
            required
            />
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          <input
            matInput
            id="firstName"
            formControlName="firstName"
            required
            />
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input
            matInput
            id="lastName"
            formControlName="lastName"
            required
            />
        </mat-form-field>
      </div>
    </form>
  </app-card>

  <app-card title="Groups">
    @if (favoriteGroupMembership) {
      <div class="favorite-group">
        <h4>Favorite Group:</h4>
        <span class="group-name">{{ favoriteGroupMembership.groups.groupName }}</span>
        <h4>Time Period:</h4>
        <span>{{ favoriteGroupMembership.groups.trackingPeriodStart | date: 'd.MM.yyyy' }} - {{ favoriteGroupMembership.groups.trackingPeriodFinish | date: 'd.MM.yyyy' }}</span>
      </div>
    }
    @if (groupMemberships && groupMemberships.length > 0) {
      <div class="group-list">
        <h3>Your Groups:</h3>
        @for (gm of groupMemberships; track gm) {
          <div class="group-row">
            <span class="group-name">{{ gm.groups.groupName }}</span>
            <div class="group-actions">
              <app-icon
                name="star"
                [color]="gm.isFavorite ? 'gold' : 'gray'"
                (click)="onSetFavoriteGroup(gm.groups.id)"
                class="clickable-icon favorite-star"
                [matTooltip]="gm.isFavorite ? 'Current favorite' : 'Set as new favorite'"
                matTooltipPosition="left"
                >
              </app-icon>
              <app-icon
                name="logout"
                color="black"
                (click)="onLeaveGroup(gm.groups.id)"
                class="clickable-icon"
                matTooltip="Leave group"
                matTooltipPosition="right"
                >
              </app-icon>
            </div>
          </div>
        }
      </div>
    } @else {
      <p>You are not part of any groups.</p>
    }

    <!-- Join group by code -->
    <div class="add-group">
      <h3>Join a new group</h3>
      <form [formGroup]="groupCodeForm">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Group Code</mat-label>
            <input matInput formControlName="groupCode" required />
          </mat-form-field>
        </div>
        <div class="form-actions">
          <button
            class="btn"
            [disabled]="groupCodeForm.invalid"
            (click)="onSubmitGroupCode()"
            >
            <app-icon name="groups"></app-icon>
            Join group
          </button>
        </div>
      </form>
    </div>

  </app-card>

  <!-- Profile deletion -->
  <app-card title="Delete Profile">
    <p>
      Deleting your profile will anonymize all your personal data and your
      entries and remove your profile from the system. You will not be able to
      retrieve your data. Your SWITCH Account will not be affected by this action.
    </p>
    <p>
      <strong>This action cannot be undone.</strong>
    </p>
    <button
      class="btn btn-delete"
      (click)="onDeleteProfile()"
      title="Delete your profile and anonymize all associated data"
      >
      <app-icon name="trash"></app-icon>
      Delete Profile
    </button>
  </app-card>
</div>


<!-- Deprecated JWT authentication - commented out for potential future reintegration.
<app-card title="Account Information" class="profile-card">
  <form [formGroup]="profileForm">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input
          matInput
          id="username"
          formControlName="username"
          (change)="updateProfileErrorMessages()"
          required
          />
        <mat-error *ngIf="fieldErrors()['username']">{{
          fieldErrors()["username"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input
          matInput
          id="email"
          type="email"
          formControlName="email"
          (change)="updateProfileErrorMessages()"
          required
          />
        <mat-error *ngIf="fieldErrors()['email']">{{
          fieldErrors()["email"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input
          matInput
          id="firstName"
          formControlName="firstName"
          (change)="updateProfileErrorMessages()"
          required
          />
        <mat-error *ngIf="fieldErrors()['firstName']">{{
          fieldErrors()["firstName"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          id="lastName"
          formControlName="lastName"
          (change)="updateProfileErrorMessages()"
          required
          />
        <mat-error *ngIf="fieldErrors()['lastName']">{{
          fieldErrors()["lastName"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-actions">
      <button
        class="btn"
        [disabled]="profileForm.invalid"
        (click)="onSubmitProfile()"
        >
        Update Profile
      </button>
    </div>
  </form>
</app-card>

<!-- Password Update Form --
<app-card title="Change Password" *ngIf="isOidcUser === false">
  <form [formGroup]="passwordForm">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>New Password</mat-label>
        <input
          matInput
          id="password"
          type="password"
          formControlName="password"
          (change)="updatePasswordErrorMessages()"
          required
          />
        <mat-error *ngIf="passwordErrors()['password']">{{
          passwordErrors()["password"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Confirm New Password</mat-label>
        <input
          matInput
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          (change)="updatePasswordErrorMessages()"
          required
          />
        <mat-error *ngIf="passwordErrors()['confirmPassword']">{{
          passwordErrors()["confirmPassword"]
        }}</mat-error>
      </mat-form-field>
    </div>

    <div class="form-actions">
      <button
        class="btn"
        [disabled]="passwordForm.invalid"
        (click)="onSubmitPassword()"
        >
        <app-icon name="key"></app-icon>
        Update password
      </button>
    </div>
  </form>
</app-card>
-->

